import React from 'react'
import { AdvertorialTemplate, SEO } from '@/components'
import { buildStaticPaths, buildStaticProps } from '../../../ssg/advertorial'

function AutoInsuranceAdvertorial(props: any) {
  const { seoTitle, seoDescription, ...templateProps } = props
  return (
    <>
      <SEO title={seoTitle || props.title} description={seoDescription} />
      <AdvertorialTemplate {...templateProps} />
    </>
  )
}

export async function getStaticPaths() {
  return buildStaticPaths('auto-insurance')
}

export async function getStaticProps({
  params,
}: {
  params: {
    slug: string
  }
}) {
  const { props } = await buildStaticProps(params)
  return { props }
}

export default AutoInsuranceAdvertorial
